import { Checkbox as AntCheckbox } from 'antd';
import styled from 'styled-components';

export const Checkbox = styled(AntCheckbox)`
  height: 1rem;

  .ant-checkbox {
    top: 0;
  }

  &.ant-checkbox-wrapper {
    align-items: center;
  }

  .ant-checkbox-disabled .ant-checkbox-inner {
    background-color: inherit;
  }

  .ant-checkbox-checked .ant-checkbox-inner {
    box-shadow: var(--shadow-highlight)
      rgba(var(--blue-60-in-rgb), var(--shadow-highlight-color-opacity));
  }

  .ant-checkbox-checked.ant-checkbox-disabled .ant-checkbox-inner {
    background-color: var(--gray-20);
    box-shadow: var(--shadow-highlight)
      rgba(224, 224, 224, var(--shadow-highlight-color-opacity));
  }

  .ant-checkbox-indeterminate .ant-checkbox-inner {
    background-color: var(--primary-color);
    border-color: var(--primary-color);
    box-shadow: var(--shadow-highlight)
      rgba(var(--blue-60-in-rgb), var(--shadow-highlight-color-opacity));
  }

  .ant-checkbox-indeterminate .ant-checkbox-inner::after {
    background-color: var(--white-100);
    width: 8px;
    height: 2px;
    border-radius: 1px;
  }

  & + & {
    margin: 0;
  }
`;
